export default __webpack_public_path__ + "static/media/roberto-podadera-padre.e599289c.webp";